<template>
	<div class="container">
		<div class="top_title">
			<router-link class="icon_back" :to="{name:'H010010'}" tag="span"></router-link>
			<p>拓展阅读</p>
			<span class="icon_search1" style="float: right;position: absolute;top: 0;right: 0.6rem;"
				@click="clickSearchBtn()"></span>
		</div>
		<div class="weui-flex top_tabs">
			<div class="weui-flex__item"><span :class="{active: tabFlag == false}" @click="clickTab(1)">推荐阅读</span>
			</div>
			<div class="weui-flex__item"><span :class="{active: tabFlag == true}" @click="clickTab(2)">我的阅读</span></div>
		</div>
		<!-- <div id="warpId"> -->
		<!-- <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit"> -->
		<div class="scroll_area" style="overflow-y: scroll">
			<!--mescroll滚动区域的基本结构-->
			<mescroll-vue ref="mescroll" :up="mescrollUp" @init="mescrollInit">
				<div v-if="dataList.length > 0" class="weui-grids" style="overflow-y: auto">
					<router-link v-for="item,index in dataList" tag="div" class="weui-grid"
						:to="{name: item.I_HTML_NAME, params:{id: item.I_BOOK_NO_SYS,I_PAGE_NO: item.I_PAGE_NO, searchInput:searchInput,I_LEVEL_CODE:I_LEVEL_CODE,I_FLAG:I_FLAG,tabFlag:tabFlag}}"
						:key="item.id">
						<img :src="item.I_TITLE_ICON" />
						<p class="title" style="-webkit-box-orient: vertical;">{{item.I_TITLE_1}}</p>
						<span v-if="item.I_FINISH_FLAG == 'Y' && I_FLAG == '我的'" class="isFinsh"></span>
						<span class="triangle"></span>
						<span class="level">{{item.I_LEVEL_NAME}}</span>
					</router-link>
				</div>
				<!-- 				<p v-if="dataList.length > 0"
					style="height: 30px;line-height: 30px;text-align: center;color: #aaa;font-size: 0.9rem;">
					{{loadState}}
				</p> -->

				<template v-if="dataList.length == 0">
					<NoRecord Message="无查询记录"></NoRecord>
				</template>
			</mescroll-vue>
		</div>
		<!-- 			</mescroll-vue> -->
		<!-- </div> -->

		<!--底部导航-->
		<Footer :navs="nav"></Footer>

		<div class="overlayer">
			<div class="modal">
				<span class="icon_close" @click="closeModal()"></span>
				<div class="modal_contents">
					<p class="title">搜索/筛选</p>
					<div class="search">
						<input class="input_search" v-model="searchInput" type="text" placeholder="输入关键词搜索(书名/级别/内容)" />
						<span class="icon_search" @click="clickSearch1"></span>
					</div>
					<p class="level_title">级别筛选</p>
					<div class="select_items">
						<div class="select_item">
							<span class="selection" :class="{active:I_LEVEL_CODE == '全部'}"
								@click="clickSearch2('全部')">全部</span>
						</div>
						<div v-for="item in overlayerList" class="select_item">
							<span class="selection" :class="{active:I_LEVEL_CODE == item.I_LEVEL_NAME}"
								@click="clickSearch2(item.I_LEVEL_NAME)">{{item.I_LEVEL_NAME}}</span>
						</div>
					</div>
					<div class="weui-flex bottom_btns">
						<div class="weui-flex__item" @click="reset()">
							重置
						</div>
						<div class="weui-flex__item" @click="clickConfirm()">
							确定
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DataRequestFactory from '@/factories/dataRequestFactory.js'
	import Footer from '../components/Footer.vue'
	import weui from 'weui.js'
	import NoRecord from '../components/NoRecord.vue'
	import MescrollVue from 'mescroll.js/mescroll.vue'

	// import jsonp from '@/common/jsonp.js'
	// import axios from '@/common/axios.js'
	// import {jsonpCommonOption, axiosCommonOption, ajaxUrl,qqMapKey} from '@/common/config'

	// import MescrollVue from 'mescroll.js/mescroll.vue'

	export default {
		// components: {
		// 	MescrollVue // 注册mescroll组件
		// },
		name: '',
		data() {
			return {
				nav: {
					sy: true,
					jchd: false,
					yyst: false,
					wd: false,
				},
				tabFlag: false,
				dataList: [],
				I_FLAG: "",
				overlayerList: [],
				I_LEVEL_CODE: "全部",
				searchInput: "",
				tempList: [],
				listLength: 0,
				count: 2,
				loadState: "加载中......",
				message: "",

				mescroll: null,
				mescrollUp: {
					callback: this.upCallback, 
					page: {
						num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
						size: 10 //每页数据条数,默认10
					},
					htmlNodata: '<p class="upwarp-nodata" style="padding-bottom: 3rem;">-- 加载完成 --</p>',
					noMoreSize: 3, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;
				},
			}
		},
		// beforeRouteEnter(to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteEnter不用写
		// 	next(vm => {
		// 		// 滚动到原来的列表位置,恢复顶部按钮和isBounce的配置
		// 		vm.$refs.mescroll && vm.$refs.mescroll.beforeRouteEnter()
		// 	})
		// },
		// beforeRouteLeave(to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteLeave不用写
		// 	// 记录列表滚动的位置,隐藏顶部按钮和isBounce的配置
		// 	this.$refs.mescroll && this.$refs.mescroll.beforeRouteLeave()
		// 	next()
		// },
		components: {
			Footer,
			NoRecord,
			MescrollVue
		},
		created() {
			this.searchInput = this.$route.params.searchInput
			this.I_LEVEL_CODE = this.$route.params.I_LEVEL_CODE
			this.I_FLAG = this.$route.params.I_FLAG
			this.tabFlag = this.$route.params.tabFlag || false
			// let params = {
			// 	"I_FLAG": this.I_FLAG,
			// 	"I_SEARCH_FIELD": this.searchInput,
			// 	"I_LEVEL_NAME": this.I_LEVEL_CODE
			// }
			// // this.I_FLAG = '全部'
			// DataRequestFactory.I050010(params).then((response) => {
			// 	if (response.dataList.length == 0) {
			// 		this.message = '无查询记录！'
			// 	} else {
			// 		this.message = ''
			// 	}
			// 	if (response.dataList.length <= 12) {
			// 		this.loadState = "加载完成"
			// 	} else {
			// 		this.loadState = "加载中......"
			// 	}
			// 	this.dataList = response.dataList
			// 	this.listLength = response.dataList.length
			// 	this.tempList = this.dataList.splice(0, 12)
			// })
			let params = {
				"I_FLAG": this.I_FLAG,
				"I_SEARCH_FIELD": this.searchInput,
				"I_LEVEL_NAME": this.I_LEVEL_CODE,
				"I_PAGE_NUM": 1,
				"I_PAGE_SIZE": 1,
			}
			DataRequestFactory.I050010(params).then((response) => {
				this.mescrollUp.page.size=response.pageSize
			})
			DataRequestFactory.I050011().then((response) => {
				this.overlayerList = response.dataList
			})
		},
		methods: {
			mescrollInit(mescroll) {
				this.mescroll = mescroll // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
			},
			upCallback(page, mescroll) {
				let params = {
					"I_FLAG": this.I_FLAG,
					"I_SEARCH_FIELD": this.searchInput,
					"I_LEVEL_NAME": this.I_LEVEL_CODE,
					"I_PAGE_NUM": page.num,
					"I_PAGE_SIZE": page.size,
				}
				DataRequestFactory.I050010(params).then((response) => {
					if (page.num === 1) this.dataList = []
					this.dataList = this.dataList.concat(response.dataList)
					this.$nextTick(() => {
						mescroll.endBySize(Number(response.dataCount),Number(response.dataMaxCount))
					})
				}).catch(err => {
					mescroll.endErr()
				})
			},
			reset() {
				this.searchInput = ""
				this.I_LEVEL_CODE = "全部"
			},
			closeModal() {
				$(".overlayer").css("display", "none")
			},
			clickSearchBtn() {
				$(".overlayer").css("display", "block")
				this.searchInput = ""
				this.I_LEVEL_CODE = "全部"
			},
			// clickSearch1() {
			// 	let params = {
			// 		"I_FLAG": this.I_FLAG,
			// 		"I_SEARCH_FIELD": this.searchInput
			// 	}
			// 	DataRequestFactory.I110010(params).then((response) => {
			// 		$(".overlayer").css("display", "none")
			// 		$(".scroll_area").scrollTop(0)
			// 		if (response.dataList.length == 0) {
			// 			this.message = '无查询记录！'
			// 		} else {
			// 			this.message = ''
			// 		}
			// 		if (response.dataList.length <= 12) {
			// 			this.loadState = "加载完成"
			// 		} else {
			// 			this.loadState = "加载中......"
			// 		}
			// 		this.dataList = response.dataList
			// 		this.showMsg = response.showMsg
			// 		//          this.listLength = response.dataList.length
			// 		//          this.tempList = this.dataList.splice(0,12)
			// 	})
			// },
			reset() {
				this.searchInput = ""
				this.I_LEVEL_CODE = "全部"
			},
			closeModal() {
				$(".overlayer").css("display", "none")
			},
			clickSearchBtn() {
				$(".overlayer").css("display", "block")
				// this.searchInput = ""
				// this.I_LEVEL_CODE = "全部"
			},
			clickSearch1() {
				let params = {
					"I_FLAG": this.I_FLAG,
					"I_SEARCH_FIELD": this.searchInput
				}
				// DataRequestFactory.I050010(params).then((response) => {
					$(".overlayer").css("display", "none")
					this.mescroll.resetUpScroll()
					// $(".scroll_area").scrollTop(0)
					// if (response.dataList.length == 0) {
					// 	this.message = '无查询记录！'
					// } else {
					// 	this.message = ''
					// }
					// if (response.dataList.length <= 12) {
					// 	this.loadState = "加载完成"
					// } else {
					// 	this.loadState = "加载中......"
					// }
					// this.dataList = response.dataList
					// this.listLength = response.dataList.length
					// this.tempList = this.dataList.splice(0, 12)
				// })
			},
			clickSearch2(value) {
				this.I_LEVEL_CODE = value
			},
			clickConfirm() {
				let params;
				if (this.I_LEVEL_CODE == '全部') {
					// params = {
					// 	"I_FLAG": this.I_FLAG,
					// 	"I_LEVEL_NAME": "",
					// 	"I_SEARCH_FIELD": this.searchInput,
					// }
					this.I_LEVEL_CODE=""
				} else {
					// params = {
					// 	"I_FLAG": this.I_FLAG,
					// 	"I_SEARCH_FIELD": this.searchInput,
					// 	"I_LEVEL_NAME": this.I_LEVEL_CODE
					// }
				}
				this.mescroll.resetUpScroll()
				// DataRequestFactory.I050010(params).then((response) => {
					$(".overlayer").css("display", "none")
				// 	$(".scroll_area").scrollTop(0)
				// 	if (response.dataList.length == 0) {
				// 		this.message = '无查询记录！'
				// 	} else {
				// 		this.message = ''
				// 	}
				// 	if (response.dataList.length <= 12) {
				// 		this.loadState = "加载完成"
				// 	} else {
				// 		this.loadState = "加载中......"
				// 	}
				// 	this.dataList = response.dataList
				// 	this.listLength = response.dataList.length
				// 	this.tempList = this.dataList.splice(0, 12)
				// })
			},
			clickTab(value) {
				let vm = this
				this.count = 2
				this.searchInput = ""
				this.I_LEVEL_CODE = "全部"
				if (value == 1) {
					this.tabFlag = false
					// let params = {
					// 	"I_FLAG": "全部",
					// 	"I_SEARCH_FIELD": ""
					// }
					this.I_FLAG = '全部'
					this.mescroll.resetUpScroll()
					// DataRequestFactory.I050010(params).then((response) => {
					// 	$(".scroll_area").scrollTop(0)
					// 	if (response.dataList.length == 0) {
					// 		this.message = '无查询记录！'
					// 	} else {
					// 		this.message = ''
					// 	}
					// 	if (response.dataList.length <= 12) {
					// 		this.loadState = "加载完成"
					// 	} else {
					// 		this.loadState = "加载中......"
					// 	}
					// 	this.dataList = response.dataList
					// 	this.listLength = response.dataList.length
					// 	this.tempList = this.dataList.splice(0, 12)

					// 	setTimeout(function() {
					// 		$(".scroll_area").scrollTop(0)
					// 		vm.count = 2
					// 	}, 500)
					// })
				} else {
					this.tabFlag = true
					// let params = {
					// 	"I_FLAG": "我的",
					// 	"I_SEARCH_FIELD": ""
					// }
					this.I_FLAG = '我的'
					this.mescroll.resetUpScroll()
					// DataRequestFactory.I050010(params).then((response) => {
					// 	$(".scroll_area").scrollTop(0)
					// 	if (response.dataList.length == 0) {
					// 		this.message = '无查询记录！'
					// 	} else {
					// 		this.message = ''
					// 	}
					// 	if (response.dataList.length <= 12) {
					// 		this.loadState = "加载完成"
					// 	} else {
					// 		this.loadState = "加载中......"
					// 	}
					// 	this.dataList = response.dataList
					// 	this.listLength = response.dataList.length
					// 	this.tempList = this.dataList.splice(0, 12)

					// 	setTimeout(function() {
					// 		$(".scroll_area").scrollTop(0)
					// 		vm.count = 2
					// 	}, 500)
					// })
				}
			},
			// //获取滚动条当前的位置
			// getScrollTop() {
			// 	var scrollTop = 0;
			// 	if (document.documentElement && document.documentElement.scrollTop) {
			// 		scrollTop = document.documentElement.scrollTop;
			// 	} else if (document.body) {
			// 		scrollTop = document.body.scrollTop;
			// 	}
			// 	return scrollTop;
			// },
			// //获取当前可视范围的高度
			// getClientHeight() {
			// 	var clientHeight = 0;
			// 	if (document.body.clientHeight && document.documentElement.clientHeight) {
			// 		clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
			// 	} else {
			// 		clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
			// 	}
			// 	return clientHeight;
			// },
			// //获取文档完整的高度
			// getScrollHeight() {
			// 	return Math.max(document.body.scrollHeight, $('.container')[0].scrollHeight);
			// }
		},
		mounted() {
			let screenHeight = window.innerHeight;
			let fontSize = getComputedStyle(window.document.documentElement)['font-size']
			let heightDiff = screenHeight - parseInt(fontSize) * 7.8
			$(".scroll_area").css("height", heightDiff + "px")

			// let vm = this
			// $(".scroll_area").scroll(function() {
			// 	if ($(this)[0].scrollTop + $(this)[0].clientHeight + 15 > $(this)[0].scrollHeight) {
			// 		if (vm.count <= Math.ceil(vm.listLength / 3)) {
			// 			if (vm.count + 1 >= Math.ceil(vm.listLength / 3)) {
			// 				vm.loadState = "加载完成"
			// 			}
			// 			var list = vm.dataList.splice(0, 3)
			// 			vm.tempList = vm.tempList.concat(list);

			// 			vm.count++;
			// 		}
			// 	}
			// })
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import '../assets/css/pages/H050010.css';
	@import '../assets/css/common.css';

	/*通过fixed固定mescroll的高度*/
	.mescroll {
		position: fixed;
		top: 4.8rem;
		bottom: 0;
		height: auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/H050010.vue